export default __webpack_public_path__ + "static/media/Saly-17.7a8950a6.svg";